import { useState } from "react";

import SVGSprite from "@/components/Atoms/SVGSprite";
import Typography from "@/foundation/Typography/V2";

import CallbackModal from "../CallbackModal";

import { classNameGenerator, clsx } from "@/utils";

import styles from "./CallbackSection.module.scss";
import { useAppSelector } from "@/hooks";

interface CallbackSectionProps {
  variant?: string;
  titleText?: string;
  descriptionText?: string;
}

const CallbackSection: React.FC<CallbackSectionProps> = ({ variant = "", titleText="", descriptionText="" }) => {
  const cls = classNameGenerator(styles);

  const [showCallbackModal, setShowCallbackModal] = useState(false);
  const { data } = useAppSelector((state) => state.bootCamp);
  const { showCallbackStrip=true } = data
  
  if(!showCallbackStrip)
    return <></>
    
  const title = titleText || "Want to know our plans better?";
  const description = descriptionText || "Request a callback";
  const formTitle = "Speak to our team!";
  const formSubtitle = "You'll get a call back in 24 hours!";

  return (
    <section className={clsx(cls("callbackSection"), cls(variant))}>
      <div
        className={cls("container")}
        onClick={() => setShowCallbackModal(true)}
      >
        <div className={cls("leftSection")}>
          <div className={cls("iconWrapper")}>
            <SVGSprite icon="icon-bootcamp-phone" className={cls("icon")} />
          </div>
          <div className={cls("content")}>
            <Typography variant="heading3" className={cls("title")}>
              {title}
            </Typography>
            <Typography variant="paragraph1" className={cls("description")}>
              {description}
            </Typography>
          </div>
        </div>
        <div className={cls("rightSection")}>
          <SVGSprite icon="icon-header-chevron-right" className={cls("icon")} />
        </div>
      </div>
      <CallbackModal
        title={formTitle}
        subtitle={formSubtitle}
        showModal={showCallbackModal}
        setShowModal={setShowCallbackModal}
      />
    </section>
  );
};

export default CallbackSection;
